import { useState } from "react";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import FormField from "layouts/applications/wizard/components/FormField";


const CollateralLog = ({ setOpen, collateralLogData, onSubmit }) => {
    const [attributeValue, setAttributeValue] = useState({
        text: collateralLogData.attribute_value || "",
        error: false,
        textError: "",
      });

  const changeAttributeValueHandler = (e) => {
    setAttributeValue({ ...attributeValue, text: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onSubmit(attributeValue, collateralLogData.value_id, collateralLogData.company_id);
  };

  return (
    <MDBox component="form" method="POST" onSubmit={submitHandler}>
      <MDBox display="flex" flexDirection="column" px={0} mt={2}>
        <MDBox
          sx={{
            maxHeight: "70vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <MDBox pb={1}>
          <FormField
              type="text"
              label="Attribute Value"
              name="attributeValue"
              value={attributeValue.text}
              onChange={changeAttributeValueHandler}
              error={attributeValue.error}
            />
            {attributeValue.error && (
              <MDTypography variant="caption" color="error" fontWeight="light">
                {attributeValue.textError}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>

        <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
          <MDBox mx={2}>
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              px={2}
              mx={2}
              onClick={() => setOpen(false)}
            >
              Back
            </MDButton>
          </MDBox>
          <MDButton variant="gradient" color="dark" size="small" type="submit">
            Update
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default CollateralLog;
